import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';

export default function BookTraining() {
    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="Request Training" />
                <iframe
                    height="100%"
                    width="100%"
                    src="https://product.eka.care/iframes/training-on-eka"
                ></iframe>
            </div>
        </div>
    );
}
